import { Link } from '@chakra-ui/react';
import { SubMentionComponentProps } from '@draft-js-plugins/mention/lib/Mention';
import * as React from 'react';

type IMentionProps = SubMentionComponentProps;
export const Mention: React.FC<IMentionProps> = (props) => {
  const { children } = props;

  return (
    <Link color={'blue.500'} fontWeight="semibold">
      {children}
    </Link>
  );
};
